import React from 'react';
import { Typography, Skeleton, Card, Divider } from 'antd';
import { useQuery } from 'react-query';
import { customerPortalService, ReceiptDetail as ReceiptDetailType } from '../../services/customerPortalService';
import { formatCurrency, formatDate } from '../../utils/formatters';

interface ReceiptDetailInlineMobileProps {
  token: string;
  receiptId: number;
  password: string;
}

export const ReceiptDetailInlineMobile: React.FC<ReceiptDetailInlineMobileProps> = ({ token, receiptId, password }) => {
  const { data, isLoading } = useQuery<ReceiptDetailType>(
    ['receipt-detail-inline-mobile', token, receiptId, password],
    () => customerPortalService.getReceiptDetail(token, receiptId, password),
    {
      enabled: !!token && !!receiptId && !!password,
      retry: false,
    }
  );

  if (isLoading || !data) {
    return (
      <div style={{ padding: 16, background: '#f8fafc', borderRadius: 8, marginTop: 12 }}>
        <Skeleton active paragraph={{ rows: 3 }} />
      </div>
    );
  }

  const { voucher, items } = data;
  const totalAmount = voucher.total_amount;

  return (
    <div
      style={{
        background: '#f8fafc',
        borderRadius: 12,
        border: '1px solid #e2e8f0',
        marginTop: 12,
        overflow: 'hidden',
      }}
    >
      <div style={{ padding: 16 }}>
        <div style={{ marginBottom: 16 }}>
          <Typography.Text strong style={{ fontSize: 15 }}>
            Phiếu {voucher.voucher_number}
          </Typography.Text>
          <Typography.Text type="secondary" style={{ display: 'block', fontSize: 13, marginTop: 4 }}>
            {voucher.created_at ? formatDate(voucher.created_at) : '—'}
          </Typography.Text>
        </div>

        <Divider style={{ margin: '12px 0' }}>Danh sách sản phẩm</Divider>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {items.map((item) => {
            const itemTotal = item.quantity * item.unit_price;

            return (
              <Card
                key={item.id}
                size="small"
                style={{
                  borderRadius: 8,
                  border: '1px solid #e2e8f0',
                  background: '#ffffff',
                }}
                bodyStyle={{ padding: 12 }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                  <Typography.Text strong style={{ fontSize: 14, flex: 1, textAlign: 'left' }}>
                    {item.medicine_name}
                  </Typography.Text>
                  <Typography.Text strong style={{ fontSize: 15, color: '#1890ff', marginLeft: 12 }}>
                    {formatCurrency(itemTotal)}
                  </Typography.Text>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  {item.medicine_code && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography.Text type="secondary" style={{ fontSize: 12 }}>Mã thuốc:</Typography.Text>
                      <Typography.Text style={{ fontSize: 12 }}>{item.medicine_code}</Typography.Text>
                    </div>
                  )}
                  {item.lot_number && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography.Text type="secondary" style={{ fontSize: 12 }}>Số lô:</Typography.Text>
                      <Typography.Text style={{ fontSize: 12 }}>{item.lot_number}</Typography.Text>
                    </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>Số lượng:</Typography.Text>
                    <Typography.Text style={{ fontSize: 12 }}>
                      {item.quantity} {item.unit || ''}
                    </Typography.Text>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>Đơn giá:</Typography.Text>
                    <Typography.Text style={{ fontSize: 12 }}>{formatCurrency(item.unit_price)}</Typography.Text>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>

        <Divider style={{ margin: '16px 0' }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography.Text strong style={{ fontSize: 16 }}>
            Tổng tiền:
          </Typography.Text>
          <Typography.Text strong style={{ fontSize: 18, color: '#1890ff' }}>
            {formatCurrency(totalAmount)}
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};
